import { render, staticRenderFns } from "./WorkflowFormBuilderField.vue?vue&type=template&id=0ee51905&"
import script from "./WorkflowFormBuilderField.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormBuilderField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports